export const STAGGERED_SEARCH_TYPES = {
  FRONT: 'FRONT',
  REAR: 'REAR',
  SET: 'SET'
};

export const STAGGERED_AXLE_TYPES = [
  STAGGERED_SEARCH_TYPES.FRONT,
  STAGGERED_SEARCH_TYPES.REAR
];
